/* Keep shopping grid: round add-to-cart button. Added 2026-10-06.
   Markup and product data come from sections/rr-pp-shop.liquid.

   One variant: the button adds it straight away. More than one: the button
   opens a small picker over the bottom of the photo (one row of chips per
   option, e.g. Color and Size) and "Add to cart" adds the matching variant.
   A single-value option, or a Color when there is only one, is preselected.

   Adds through window.RRTip.addVariant (assets/rr-tip.js) when it is on the
   page, which refreshes and opens the cart drawer. Otherwise it posts to
   /cart/add.js itself and tells the theme through CartLinesUpdateEvent. The
   card shows "Added · View cart" either way.

   Color dots swap the card photo to that color's variant image and
   preselect that color in the picker. "+N" opens the picker.

   window.rrAddToCart(variantId) is shared with the small add-on button
   (blocks/rr-addon.liquid): it posts to /cart/add.js, tells the theme's
   cart, and resolves to { ok, message }.

   Click handling is delegated from document; guarded so it loads once. */
(function () {
  'use strict';
  if (window.__rrShop) return;
  window.__rrShop = true;

  var CART_ICON =
    '<svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h8.9a1 1 0 0 0 1-.8L20 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>';
  var CHECK_ICON =
    '<svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function cartUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
  }

  function readData(card) {
    if (card.__rrData) return card.__rrData;
    var el = card.querySelector('[data-rr-shop-data]');
    try {
      card.__rrData = JSON.parse(el.textContent);
    } catch (e) {
      card.__rrData = null;
    }
    return card.__rrData;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function matchVariant(data, picked) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var ok = true;
      for (var j = 0; j < data.options.length; j++) {
        if (v.o[j] !== picked[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // Is there any available variant with this value, given the other picks?
  function valueAvailable(data, picked, optIndex, value) {
    return data.variants.some(function (v) {
      if (!v.a || v.o[optIndex] !== value) return false;
      for (var j = 0; j < data.options.length; j++) {
        if (j === optIndex || picked[j] == null) continue;
        if (v.o[j] !== picked[j]) return false;
      }
      return true;
    });
  }

  function notifyTheme(variantId) {
    try {
      import('@shopify/events')
        .then(function (m) {
          var Evt = m.CartLinesUpdateEvent;
          if (!Evt || !Evt.createPromise) return;
          var deferred = Evt.createPromise();
          document.dispatchEvent(
            new Evt({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: deferred.promise
            })
          );
          return fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              deferred.resolve({
                cart: Evt.createCartFromAjaxResponse ? Evt.createCartFromAjaxResponse(cart) : cart,
                detail: { items: cart.items, source: 'rr-pp-shop', itemCount: 1, didError: false }
              });
            })
            .catch(function (err) { deferred.reject(err); });
        })
        .catch(function () {});
    } catch (e) {}
  }

  function showAdded(card) {
    var btn = card.querySelector('[data-rr-shop-add]');
    var pick = card.querySelector('[data-rr-shop-pick]');
    pick.innerHTML = '';
    var done = el('p', 'rr-shop__done');
    done.setAttribute('role', 'status');
    done.appendChild(document.createTextNode('Added · '));
    var link = el('a', '', 'View cart');
    link.href = cartUrl();
    done.appendChild(link);
    pick.appendChild(done);
    pick.hidden = false;
    btn.innerHTML = CHECK_ICON;
    btn.setAttribute('data-state', 'added');
    clearTimeout(card.__rrTimer);
    card.__rrTimer = setTimeout(function () {
      pick.hidden = true;
      pick.innerHTML = '';
      btn.innerHTML = CART_ICON;
      btn.removeAttribute('data-state');
    }, 4000);
  }

  function showError(card, message) {
    var pick = card.querySelector('[data-rr-shop-pick]');
    var note = pick.querySelector('.rr-shop__done') || el('p', 'rr-shop__done');
    note.setAttribute('role', 'alert');
    note.textContent = message || "Couldn't add that one. Try the product page.";
    if (!note.parentNode) pick.appendChild(note);
    pick.hidden = false;
  }

  function addToCart(variantId) {
    // Prefer the site's shared add (assets/rr-tip.js): it re-renders and
    // opens this theme's cart drawer, which the theme's own event does not.
    if (window.RRTip && window.RRTip.addVariant) {
      return window.RRTip.addVariant(variantId, 1)
        .then(function () { return { ok: true }; })
        .catch(function (err) { return { ok: false, message: err && err.message }; });
    }
    return fetch(cartUrl() + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          return { ok: false, message: res.body && (res.body.description || res.body.message) };
        }
        notifyTheme(variantId);
        return { ok: true };
      })
      .catch(function () { return { ok: false }; });
  }
  window.rrAddToCart = addToCart;

  function add(card, variantId, goBtn) {
    if (goBtn) goBtn.disabled = true;
    addToCart(variantId).then(function (res) {
      if (res.ok) {
        showAdded(card);
      } else {
        showError(card, res.message);
        if (goBtn) goBtn.disabled = false;
      }
    });
  }

  function pickSwatch(card, dot) {
    Array.prototype.forEach.call(card.querySelectorAll('[data-rr-shop-swatch]'), function (d) {
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
    card.__rrColor = dot.getAttribute('data-rr-shop-swatch');
    var src = dot.getAttribute('data-img');
    var img = card.querySelector('.rr-shop__img--main');
    if (src && img) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      card.querySelector('.rr-shop__media').classList.add('is-swatched');
    }
    // Keep an open picker in step with the dot.
    var pick = card.querySelector('[data-rr-shop-pick]');
    if (!pick.hidden && pick.querySelector('[data-rr-shop-go]')) openPicker(card);
  }

  function renderPicker(card, data, picked) {
    var pick = card.querySelector('[data-rr-shop-pick]');
    pick.innerHTML = '';

    var top = el('div', 'rr-shop__pick-top');
    top.appendChild(el('span', '', 'Choose'));
    var x = el('button', 'rr-shop__x');
    x.type = 'button';
    x.setAttribute('data-rr-shop-close', '');
    x.setAttribute('aria-label', 'Close');
    x.innerHTML = '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    top.appendChild(x);
    pick.appendChild(top);

    data.options.forEach(function (name, i) {
      if (data.values[i].length < 2) return;
      pick.appendChild(el('span', 'rr-shop__opt-label', name));
      var chips = el('div', 'rr-shop__chips');
      chips.setAttribute('role', 'group');
      chips.setAttribute('aria-label', name);
      data.values[i].forEach(function (value) {
        var chip = el('button', 'rr-shop__chip', value);
        chip.type = 'button';
        chip.setAttribute('data-rr-shop-chip', i);
        chip.setAttribute('data-value', value);
        chip.setAttribute('aria-pressed', picked[i] === value ? 'true' : 'false');
        chip.disabled = !valueAvailable(data, picked, i, value);
        chips.appendChild(chip);
      });
      pick.appendChild(chips);
    });

    var variant = picked.indexOf(null) === -1 ? matchVariant(data, picked) : null;
    var go = el('button', 'rr-shop__go', variant && !variant.a ? 'Sold out' : 'Add to cart');
    go.type = 'button';
    go.setAttribute('data-rr-shop-go', '');
    go.disabled = !(variant && variant.a);
    pick.appendChild(go);

    pick.hidden = false;
  }

  function openPicker(card) {
    var data = readData(card);
    if (!data) return;
    var picked = data.options.map(function (name, i) {
      if (data.values[i].length === 1) return data.values[i][0];
      return null;
    });
    // Start on the first available color so only the size is left to pick.
    var colorIndex = data.options.indexOf('Color');
    if (colorIndex !== -1 && card.__rrColor && data.values[colorIndex].indexOf(card.__rrColor) !== -1) {
      picked[colorIndex] = card.__rrColor;
    }
    if (colorIndex !== -1 && picked[colorIndex] == null) {
      var first = data.variants.filter(function (v) { return v.a; })[0];
      if (first) picked[colorIndex] = first.o[colorIndex];
    }
    card.__rrPicked = picked;
    renderPicker(card, data, picked);
    var firstChip = card.querySelector('.rr-shop__chip:not(:disabled):not([aria-pressed="true"])');
    if (firstChip) firstChip.focus({ preventScroll: true });
  }

  function closePicker(card) {
    var pick = card.querySelector('[data-rr-shop-pick]');
    pick.hidden = true;
    pick.innerHTML = '';
    var btn = card.querySelector('[data-rr-shop-add]');
    if (btn) btn.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var addon = target.closest('[data-rr-addon]');
    if (addon) {
      event.preventDefault();
      if (addon.getAttribute('data-state') === 'added') {
        window.location.href = cartUrl();
        return;
      }
      addon.disabled = true;
      var label = addon.querySelector('[data-rr-addon-label]');
      addToCart(addon.getAttribute('data-rr-addon')).then(function (res) {
        addon.disabled = false;
        if (res.ok) {
          addon.setAttribute('data-state', 'added');
          if (label) label.textContent = 'Added · View cart';
        } else if (label) {
          label.textContent = 'Try again';
        }
      });
      return;
    }

    var card = target.closest('[data-rr-shop-card]');
    if (!card) return;

    if (target.closest('[data-rr-shop-add]')) {
      event.preventDefault();
      var data = readData(card);
      if (!data) return;
      var pick = card.querySelector('[data-rr-shop-pick]');
      if (!pick.hidden && pick.querySelector('[data-rr-shop-go]')) {
        closePicker(card);
        return;
      }
      if (data.variants.length === 1) {
        add(card, data.variants[0].id);
      } else {
        openPicker(card);
      }
      return;
    }

    var dot = target.closest('[data-rr-shop-swatch]');
    if (dot) {
      pickSwatch(card, dot);
      return;
    }

    if (target.closest('[data-rr-shop-add-more]')) {
      openPicker(card);
      return;
    }

    if (target.closest('[data-rr-shop-close]')) {
      closePicker(card);
      return;
    }

    var chip = target.closest('[data-rr-shop-chip]');
    if (chip) {
      var d = readData(card);
      var i = Number(chip.getAttribute('data-rr-shop-chip'));
      card.__rrPicked[i] = chip.getAttribute('data-value');
      // Drop picks the new choice made impossible (e.g. a size not made in that color).
      card.__rrPicked = card.__rrPicked.map(function (value, j) {
        if (j === i || value == null || d.values[j].length < 2) return value;
        return valueAvailable(d, card.__rrPicked, j, value) ? value : null;
      });
      renderPicker(card, d, card.__rrPicked);
      var same = card.querySelector('[data-rr-shop-chip="' + i + '"][aria-pressed="true"]');
      if (same) same.focus({ preventScroll: true });
      return;
    }

    var go = target.closest('[data-rr-shop-go]');
    if (go) {
      var v = matchVariant(readData(card), card.__rrPicked);
      if (v && v.a) add(card, v.id, go);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var target = event.target;
    if (!(target instanceof Element)) return;
    var card = target.closest('[data-rr-shop-card]');
    if (card && !card.querySelector('[data-rr-shop-pick]').hidden) closePicker(card);
  });
})();
